import { Box, Grid2 as Grid, Tab, Tabs } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import CustomDocumentOwnerTab from "../customDocumentTabs/CustomDocumentOwnerTab";
import CustomDocumentContractorTab from "../customDocumentTabs/CustomDocumentContractorTab";
import CustomDocumentRecordingTab from "../customDocumentTabs/CustomDocumentRecordingTab";
import CustomDocumentNocNotarizationTab from "../customDocumentTabs/CustomDocumentNocNotarizationTab";
import { setRightValue } from "../../../store/actions/uiActions/myPermitsActions";
import { useDispatch, useSelector } from "react-redux";
import { useTour } from "@reactour/tour";

const CustomDocumentRightContent = ({
  recordLoading,
  handleStartRecord,
  isMobile = false,
  isReadOnlyPage = false,
}) => {
  const { rightValue, selectedRow } = useSelector(
    (state) => state.myPermitsComponent,
  );

  const tabConfig = useRef([]);
  const { isOpen } = useTour();

  const notarizeTabIndex = useRef(null);
  const recordTabIndex = useRef(null);

  const [refreshRightKey, setRefreshRightKey] = useState(0);
  const [isFading, setIsFading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setRefreshRightKey((prev) => prev + 1);
  }, [selectedRow]);

  useEffect(() => {
    const isNotarizing =
      selectedRow?.document?.actions?.notarize &&
      !selectedRow?.processing_permit?.notarization?.notarized;

    const isRecording =
      selectedRow?.document?.actions?.record &&
      !selectedRow?.processing_permit?.recording?.recorded;

    if (isNotarizing && notarizeTabIndex.current !== null) {
      setIsFading(true);
      setTimeout(() => {
        dispatch(setRightValue(notarizeTabIndex.current));
        setIsFading(false);
      }, 400);
    } else if (isRecording && recordTabIndex.current !== null) {
      setIsFading(true);
      setTimeout(() => {
        setRightValue(recordTabIndex.current);
        setIsFading(false);
      }, 400);
    }
  }, [selectedRow, setIsFading, dispatch]);

  useEffect(() => {
    const config = [
      {
        label: "Property Owner",
        component: <CustomDocumentOwnerTab isReadOnlyPage={isReadOnlyPage} />,
      },
      {
        label: "Contractor",
        component: <CustomDocumentContractorTab />,
      },
    ];

    if (selectedRow?.document?.actions?.notarize) {
      notarizeTabIndex.current = config.length;
      config.push({
        label: "Notarization",
        component: (
          <CustomDocumentNocNotarizationTab isReadOnlyPage={isReadOnlyPage} />
        ),
      });
    }

    if (selectedRow?.document?.actions?.record) {
      recordTabIndex.current = config.length;
      config.push({
        label: "Recording",
        component: (
          <CustomDocumentRecordingTab
            recordLoading={recordLoading}
            handleStartRecord={handleStartRecord}
            isReadOnlyPage={isReadOnlyPage}
          />
        ),
      });
    }

    tabConfig.current = config;
  }, [
    selectedRow,
    refreshRightKey,
    handleStartRecord,
    recordLoading,
    isReadOnlyPage,
  ]);

  const handleRightChange = useCallback(
    (event, newValue) => {
      if (isOpen) return;

      setIsFading(true);
      setTimeout(() => {
        if (rightValue !== newValue) {
          dispatch(dispatch(setRightValue(newValue)));
          setIsFading(false);
        }
      }, 300);
    },
    [isOpen, rightValue, dispatch],
  );

  return (
    <Grid
      className="step16 step17 step18 step19 step20 step21"
      size={{ xs: 12, sm: 4 }}
      sx={{ borderLeft: isMobile ? "none" : "4px solid #d3d3d3" }}
    >
      <Box
        sx={{
          maxWidth: "100%",
          bgcolor: "background.paper",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Tabs
          value={rightValue}
          onChange={handleRightChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable auto tabs"
          slotProps={{
            indicator: {
              style: { height: "3px", bottom: "10px" },
            },
          }}
        >
          {tabConfig.current.map((tab, i) => (
            <Tab key={i} label={tab.label} disableRipple />
          ))}
        </Tabs>
      </Box>

      <Box
        sx={{ width: "100%" }}
        className={
          isFading
            ? "fade-exit fade-exit-active"
            : "fade-enter fade-enter-active"
        }
      >
        {tabConfig.current[rightValue]?.component || null}
      </Box>
    </Grid>
  );
};

export default React.memo(CustomDocumentRightContent);
